export const NoWrapControl = props => <div className="no-wrap-control">{props.children}</div>;